import { useIntl } from 'react-intl'

import ActionIcon from '@components/UI/ActionIcon'
import Theme from '@theme'

interface IActionBarIconSelection {
  selected?: boolean
  onToggle: VoidFunction
}

export const ActionBarIconSelection = ({ selected, onToggle }: IActionBarIconSelection) => {
  const intl = useIntl()
  return selected ? (
    <ActionIcon
      elementName="action-bar-selection-selected"
      glyph="circle-minus-solid"
      color={Theme.primaryColor}
      size={1.5}
      onClick={onToggle}
      tooltip={intl.formatMessage({
        id: 'submission.card.action.removefromselection',
      })}
    />
  ) : (
    <ActionIcon
      elementName="action-bar-selection-unselected"
      glyph="circle-plus"
      color={Theme.primaryColor}
      size={1.5}
      onClick={onToggle}
      tooltip={intl.formatMessage({
        id: 'submission.card.action.addtoselection',
      })}
    />
  )
}

export default ActionBarIconSelection
